import React from 'react';
import {Typography} from "@mui/material";
import {isMobile} from "react-device-detect";


const HeaderBlock = ({ children, className, onClick, style={fontWeight:700}, variant = 'h5' }) => {

    return (
        <Typography variant={isMobile ? 'h5' : variant} className={className} style={style} onClick={onClick}>
            {children}
        </Typography>
    );
};

export default HeaderBlock;